export default "__VITE_ASSET__BecqyJJ3__"